export default "__VITE_ASSET__RMkTeTLy__"